"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VISITOR_COOKIE = exports.USER_PREFERENCES_COOKIE = exports.PREFERRED_LOCALE_COOKIE = exports.MAX_AGE = void 0;
exports.MAX_AGE = 365; // Days -> 1 years
exports.PREFERRED_LOCALE_COOKIE = 'saatchi_preferred_locale';
exports.USER_PREFERENCES_COOKIE = 'saatchi_user_preferences';
exports.VISITOR_COOKIE = 'saatchivc';
